import * as Vue from "vue";
import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

import CoursesPage from "@/components/Admin/Content/courses/CoursesPage.vue";
import LessonsPage from "@/components/Admin/Content/lessons/LessonsPage.vue";
import LessonPage from "@/components/Admin/Content/lessons/LessonPage.vue";
import CoursesTitleBar from "@/components/Admin/Content/courses/CoursesTitleBar.vue";
import LessonTitleBar from "@/components/Admin/Content/lessons/LessonTitleBar.vue";
import LessonsTitleBar from "@/components/Admin/Content/lessons/LessonsTitleBar.vue";
import CoursePage from "@/components/Admin/Content/courses/CoursePage.vue";
import EditCoursePage from "@/components/Admin/Content/courses/EditCoursePage.vue";
import EditModuleLessonOrder from "@/components/Admin/Content/modules/EditModuleLessonOrder.vue";
import AddModule from "@/components/Admin/Content/modules/AddModule.vue";
import EditCategoryPage from "@/components/Admin/Content/taxonomy/EditCategoryPage.vue";
import EditDisciplinesPage from "@/components/Admin/Content/taxonomy/EditDisciplinesPage.vue";
import QuestionBankListPage from "@/components/Admin/Prep/QuestionBankListPage.vue";
import QuestionBankPage from "@/components/Admin/Prep/QuestionBankPage.vue";
import QuestionBankCategoryPage from "@/components/Admin/Prep/QuestionBankCategoryPage.vue";
import NewCoursePageVue from "@/components/Admin/Content/courses/NewCoursePage.vue";
import EditLessonPage from "@/components/Admin/Content/lessons/EditLessonPage.vue";
import EditCourseModuleOrder from "@/components/Admin/Content/courses/EditCourseModuleOrder.vue";
import EditModule from "@/components/Admin/Content/modules/EditModule.vue";

const routes: Readonly<RouteRecordRaw[]> = [
    // Admin Routes
    {
        path: "/content/learn/courses",
        name: "courses",
        children: [
            {
                path: "",
                components: {
                    default: CoursesPage,
                    titleBar: CoursesTitleBar,
                },
            },
            {
                path: "new",
                components: {
                    default: NewCoursePageVue,
                    titleBar: CoursesTitleBar,
                },
            },
            {
                path: ":uuid",
                children: [
                    {
                        path: "",
                        name: "course",
                        components: {
                            default: CoursePage,
                            titleBar: CoursesTitleBar,
                        },
                    },
                    {
                        path: "edit",
                        name: "course-edit",
                        components: {
                            default: EditCoursePage,
                            titleBar: CoursesTitleBar,
                        },
                        props: { default: true },
                    },
                    {
                        path: "add-module",
                        components: {
                            default: AddModule,
                            titleBar: CoursesTitleBar,
                        },
                    },
                ],
            },
        ],
    },
    {
        path: "/content/learn/courses/:uuid/module-order",
        name: "course.edit.module-order",
        components: {
            default: EditCourseModuleOrder,
            titleBar: LessonsTitleBar,
        },
        props: { default: true },
    },
    {
        path: "/content/learn/modules/:uuid/edit",
        name: "module.edit",
        components: {
            default: EditModule,
            titleBar: LessonsTitleBar,
        },
        props: { default: true },
    },
    {
        path: "/content/learn/modules/:uuid/lessons",
        name: "module_lessons",
        components: {
            default: LessonsPage,
            titleBar: LessonsTitleBar,
        },
        props: { default: true },
    },
    {
        path: "/content/learn/modules/:uuid/lessons/add",
        name: "module_lessons.add",
        components: {
            default: LessonPage,
            titleBar: LessonsTitleBar,
        },
        props: { default: true },
    },
    {
        path: "/content/learn/modules/:moduleUuid/lessons/:lessonUuid/edit",
        name: "module_lessons.edit",
        components: {
            default: EditLessonPage,
            titleBar: LessonsTitleBar,
        },
        props: true,
    },
    {
        path: "/content/learn/modules/:uuid/lesson-order",
        name: "module.edit.lesson-order",
        components: {
            default: EditModuleLessonOrder,
            titleBar: LessonsTitleBar,
        },
        props: { default: true },
    },
    {
        path: "/content/learn/lessons",
        name: "lessons",
        components: {
            default: LessonsPage,
            titleBar: LessonsTitleBar,
        },
    },
    {
        path: "/content/learn/lessons/:lessonUuid/edit",
        name: "lessons.edit",
        components: {
            default: EditLessonPage,
            titleBar: LessonsTitleBar,
        },
        props: true,
    },
    {
        path: "/content/learn/lessons/:uuid",
        name: "lesson",
        components: {
            default: LessonPage,
            titleBar: LessonTitleBar,
        },
        props: {
            default: true,
        },
    },
    {
        path: "/content/learn/categories",
        name: "manage-categories",
        components: {
            default: EditCategoryPage,
            titleBar: LessonTitleBar,
        },
        props: {
            default: true,
        },
    },
    {
        path: "/content/learn/disciplines",
        name: "manage-disciplines",
        components: {
            default: EditDisciplinesPage,
            titleBar: LessonTitleBar,
        },
        props: {
            default: true,
        },
    },
    {
        path: "/prep/banks",
        name: "banks",
        children: [
            {
                path: "",
                components: {
                    default: QuestionBankListPage,
                    titleBar: LessonTitleBar,
                },
            },
            {
                path: ":id/categories/:categoryId",
                component: QuestionBankCategoryPage,
            },
            {
                path: ":id",
                components: {
                    default: QuestionBankPage,
                    titleBar: LessonTitleBar,
                },
            },
        ],
        props: {
            default: true,
        },
    },
];

export default () => {
    return createRouter({
        history: createWebHistory("admin-portal"),
        routes: routes,
    });
};
